import { IconButton, type IconButtonProps, Tooltip, useTheme } from '@mui/material';
import { ArchiveBox, DirectSend } from 'iconsax-react';
import type { FC } from 'react';

interface ArchiveIconButtonProps extends IconButtonProps {
  isLoading?: boolean;
  isArchived: boolean;
  canArchive?: boolean;
  archiveLabel?: string;
  restoreLabel?: string;
}

export const ArchiveIconButton: FC<ArchiveIconButtonProps> = ({
  isArchived,
  isLoading = false,
  canArchive = true,
  disabled,
  archiveLabel = 'Archive',
  restoreLabel = 'Restore',
  ...props
}) => {
  const theme = useTheme();

  const Icon = isArchived ? DirectSend : ArchiveBox;

  if (!canArchive) {
    return null;
  }

  return (
    <Tooltip title={isArchived ? restoreLabel : archiveLabel}>
      <IconButton disabled={isLoading || disabled} {...props}>
        <Icon variant='TwoTone' color={theme.palette.SlabIndigo[700]} />
      </IconButton>
    </Tooltip>
  );
};
